var map = {
	"./blob.png": 4594,
	"./char1.png": 8687,
	"./char2.png": 3963,
	"./char3.png": 4982,
	"./char4.png": 2645,
	"./char5.png": 4890,
	"./char6.png": 4368,
	"./char7.png": 8132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6679;